<template>
<div>
      <section class="text-gray-700">
        <div class="container px-5 py-24 mx-auto">
          <div class="text-center mb-20">
            <h1 class="sm:text-3xl text-2xl font-medium text-center title-font text-gray-900 mb-4">
              Frequently Asked Question
            </h1>
            
          </div>
          <div class="flex flex-wrap lg:w-4/5 sm:mx-auto sm:mb-2 -mx-2">
            <div class="w-full lg:w-1/2 px-4 py-2">
              <details class="mb-4">
                <summary class="font-semibold  bg-gray-200 rounded-md py-2 px-4">
                  How long will it take to complete the project?
                </summary>

                <span>
                 This entirely depends on the nature of the job, 
                 it may take 3-6 days or more all depending on how big the job turns out to be.
                </span>
              </details>
              <details class="mb-4">
                <summary class="font-semibold bg-gray-200 rounded-md py-2 px-4">
                  How much will the project cost all together?
                </summary>

                <span>
                We prepare a detailed quotation that answers this question showing
                the unit price per square meter of the materials being used in the project. 
                </span>
              </details>
              <details class="mb-4">
                <summary class="font-semibold  bg-gray-200 rounded-md py-2 px-4">
                  What profiles do you provide?
                </summary>

                <span>
                 We provide 3 different types of aluminium profiles which are; European, Middle East and South African profile.
                </span>
              </details>
            </div>
            <div class="w-full lg:w-1/2 px-4 py-2">
              <details class="mb-4">
                <summary class="font-semibold  bg-gray-200 rounded-md py-2 px-4">
                  What payment methods do you accept?
                </summary>

                <span class="px-4 py-2">
                  We accept visa, mobile money, cash, and even cheques
                </span>
              </details>
              <details class="mb-4">
                <summary class="font-semibold  bg-gray-200 rounded-md py-2 px-4">
                  Do you sell steel?
                </summary>

                <span class="px-4 py-2">
                 No we don't, we fabricate steel.
                </span>
              </details>
              <details class="mb-4">
                <summary class="font-semibold  bg-gray-200 rounded-md py-2 px-4">
                  Do you offer maintenance services for what you build?
                </summary>

                <span class="px-4 py-2">
                 That depends on the contract we agree upon, we offer renovation and maintenance if that's what was agreed upon.
                </span>
              </details>
            </div>
          </div>
        </div>
      </section>
    </div>
    </template>

    <script>
export default {
  name: "Faq",
  data() {
    return {};
  },
};
</script> 

<style scoped>
</style>